export default __webpack_public_path__ + "static/media/resumereview.8f493768.gif";